import { useCallback, useEffect, useRef, useState } from 'react';
import { storage } from '../../utils/platform';
import { openExternalUrl, urlToWeb } from '../utils/external';
import { API_BASE } from '../../config/api';

async function fetchJson(url, options = {}) {
  const res = await fetch(url, options);
  let payload = null;
  try { payload = await res.json(); } catch (_) {}
  if (!res.ok) {
    const err = new Error(payload?.error || `HTTP ${res.status}`);
    err.status = res.status;
    err.payload = payload;
    throw err;
  }
  return payload;
}

export function useCsvImports() {
  const [imports, setImports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const cancelRef = useRef(false);

  const getHeaders = useCallback(async () => {
    const token = await storage.get('token');
    return token
      ? { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
      : { 'Content-Type': 'application/json' };
  }, []);

  const fetchImports = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const headers = await getHeaders();
      const data = await fetchJson(`${API_BASE}/api/csv-import/imports`, { headers });
      if (cancelRef.current) return;
      setImports(Array.isArray(data?.imports) ? data.imports : []);
    } catch (e) {
      console.warn('[useCsvImports] fetchImports failed:', e.message);
      if (!cancelRef.current) setError(e.message);
    } finally {
      if (!cancelRef.current) setLoading(false);
    }
  }, [getHeaders]);

  const openWebUpload = useCallback(() => {
    openExternalUrl(urlToWeb('/configuration'));
  }, []);

  useEffect(() => {
    cancelRef.current = false;
    fetchImports();
    return () => { cancelRef.current = true; };
  }, [fetchImports]);

  return { imports, loading, error, refresh: fetchImports, openWebUpload };
}
